import React, { useEffect, useLayoutEffect } from "react";
import MainLayout from "../../layout/MainLayout";
import ProMobMid from "../../assets/svg/pro-mob-mid.svg";
import ProMob2Mid from "../../assets/svg/pro-mob-3-mid.svg";
import ProWebSide from "../../assets/svg/pro-web-side.svg";
import ProWeb2Side from "../../assets/svg/pro-web-3-side.svg";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import KeyBenfits from "./keyBenfits";
import ProsureForm from "./prosureForm";
import { useDispatch, useSelector } from "react-redux";
import { resetDetail } from "../../store/reducers/prosure";
import { resetPrice } from "../../store/reducers/home";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import { fetchVerification } from "../../store/reducers/authentication/apiThunk";
import { AppDispatch } from "../../store/store";
import {
  resetLogin,
  updateAuthKey,
  updatelogin,
} from "../../store/reducers/authentication";
import { updateLoading } from "../../store/reducers/loader";

function Home() {
  const dispatch = useDispatch<AppDispatch>();
  const authKey: any = useSelector((state: any) => state);
  useEffect(() => {
    dispatch(resetDetail({}));
    dispatch(resetPrice(0));
    dispatch(updateLoading(false))
  }, []);

  const isAuth = async () => {
    const params = new URLSearchParams(window.location.search);
    const agentId = params.get("agent_id"); // Extract agent_id from query params
    if (agentId) {
      const data: any = {
        source: params.get("source"),
        password: params.get("password")?.trim(),
        agent_id: agentId, // Use the agent_id from the URL
      };
      // Call API if agent_id exists
      try {
        const res = await dispatch(fetchVerification(data)).unwrap(); // Unwraps to return raw result or throw error
        if (res?.status === 1 && res?.data === "agent verified") {
          //@ts-ignore
          dispatch(updateAuthKey(true));
          dispatch(updatelogin(data));
          window.location.href = ROUTE_PATH.HOME;
        } else {
          dispatch(resetLogin());
          window.location.href = ROUTE_PATH.UN_AUTH;
        }
      } catch (error) {
        dispatch(resetLogin());
        window.location.href = ROUTE_PATH.UN_AUTH;
        console.error("Error saving user data:", error);
      }
    } else {
      window.location.href = ROUTE_PATH.UN_AUTH;
    }
  };
  useEffect(() => {
    if (authKey?.authentication?.authKey === false) {
      isAuth();
    }
  }, []);
  return (
    <MainLayout>
      <div className="lg:pl-[60px] lg:pr-[0] lg:pb-[80px] lg:pt-[0] pt-[50px] px-[16px] pb-[16px]">
        <div className="block lg:flex">
          <div className="lg:w-1/2 lg:pt-[60px] lg:pr-[30px]">
            <div className="flex justify-center flex-col lg:block">
              <img
                src={CoversureLogo}
                alt="CoversureLogo"
                className="h-[30px] lg:h-[44px]"
              />
              {/* <div className="lg:text-[48px] lg:leading-[49px] text-text-color-5 font-extrabold pt-[12px] text-[24px] leading-[24px] text-center lg:text-start">
                ProSure
              </div> */}
            </div>
            <div>
              <img
                src={ProMob2Mid}
                alt="ProMob2Mid"
                className="lg:hidden w-[100%] pt-[19px]"
              />
              <img
                src={ProWeb2Side}
                alt="ProWeb2Side"
                className="hidden lg:block pt-[73px]"
              />
            </div>
            <div className="lg:pt-[160px] pt-[19px]">
              <div className="block lg:hidden">
                <ProsureForm />
              </div>
              <div className="hidden lg:block">
                <KeyBenfits />
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 lg:pt-[60px]">
            <div className="block lg:hidden">
              <KeyBenfits />
            </div>
            <div className="hidden lg:block sticky right-0 top-[50px] w-[100%]">
              <ProsureForm />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default Home;
